<script setup>
import { onMounted, computed } from "vue"
import { RouterView, useRoute } from "vue-router"
import { useHead } from '@vueuse/head'

const route = useRoute()
const BASE_URL = 'https://stageisthestreet.com'

// hreflang global: indica a Google que cada página está disponible en 4 idiomas
const hreflangLinks = computed(() => {
  const path = route.fullPath
  const url = `${BASE_URL}${path}`
  return [
    { rel: 'alternate', hreflang: 'es', href: url },
    { rel: 'alternate', hreflang: 'en', href: url },
    { rel: 'alternate', hreflang: 'eu', href: url },
    { rel: 'alternate', hreflang: 'ca', href: url },
    { rel: 'alternate', hreflang: 'x-default', href: url },
  ]
})

useHead({
  link: hreflangLinks,
})

onMounted(() => {
  // Script para anuncios Google Ads si el usuario dio consentimiento
  /*if (localStorage.getItem("cookieConsent") === "all") {
    const adsScript = document.createElement("script")
    adsScript.async = true
    adsScript.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8335154798852284"
    adsScript.setAttribute("crossorigin", "anonymous")
    document.head.appendChild(adsScript)
  }*/

  // Insertar JSON-LD para organización en el head
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "sits",
    "email": "mailto:contacto@stageisthestreet.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Bizkaia",
      "addressCountry": "ES"
    },
    "url": "https://stageisthestreet.com",
    "description": "Organización dedicada a eventos",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "mailto:contacto@stageisthestreet.com"
    },
    "category": "Eventos"
  }

  const ldScript = document.createElement("script")
  ldScript.type = "application/ld+json"
  ldScript.text = JSON.stringify(jsonLd)
  document.head.appendChild(ldScript)
})
</script>

<template>
  <RouterView />
  <!--<CookieConsent />-->
</template>
<style>
.page-content {

  min-height: calc(100vh - 78px); /* Ajusta según la altura del footer */
}</style>